import { render, staticRenderFns } from "./FormItemsModelInput.vue?vue&type=template&id=2317f2fa&"
import script from "./FormItemsModelInput.vue?vue&type=script&lang=ts&"
export * from "./FormItemsModelInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports